import React, { useEffect } from 'react';
import './Testimonials.css';
import { useLanguage } from '../context/LanguageContext';

const Testimonials = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const testimonialsData = [
    {
      id: 1,
      name: 'Yusuf Ceylan',
      role: 'Kurucu',
      company: 'YC Sigorta',
      companyUrl: 'https://ycsigorta.net',
      project: 'Kurumsal Web Sitesi & WhatsApp Teklif Yönetimi',
      avatarText: 'YC',
      rating: 5,
      comment: 'Emeğine sağlık, gerçekten içime sinen çok güzel bir çalışma oldu. 🙏 İlgin ve özverin için çok teşekkür ederim. YC Sigorta için güzel bir başlangıç oldu. Daha nice güzel işlerde birlikte çalışmak dileğiyle. 🤝',
      badge: 'Doğrulanmış Müşteri',
      date: '2025'
    }
  ];

  return (
    <div className="testimonials-page-wrapper">
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <section className="testimonials-section" style={{ padding: '40px 0 80px 0' }}>
          <div className="section-header">
            <div className="section-badge">
              <i className="fa-solid fa-comments"></i>
              <span>{t('testimonials.badge')}</span>
            </div>
            <h1 className="section-title">{t('testimonials.title')}</h1>
            <p className="section-subtitle">{t('testimonials.subtitle')}</p>
          </div>

        <div className="testimonials-grid">
          {testimonialsData.map((item) => (
            <div key={item.id} className="testimonial-card">
              <div className="testimonial-top">
                <div className="rating-stars">
                  {[...Array(item.rating)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star"></i>
                  ))}
                </div>
                <span className="verified-badge">
                  <i className="fa-solid fa-circle-check"></i> {item.badge}
                </span>
              </div>

              {item.comment ? (
                <p className="testimonial-comment">"{item.comment}"</p>
              ) : (
                <div className="testimonial-comment-placeholder" style={{ minHeight: '48px' }}></div>
              )}

              <div className="testimonial-project">
                <i className="fa-solid fa-code-commit"></i>
                <span>{item.project}</span>
              </div>

              <div className="testimonial-author">
                <div className="author-avatar">{item.avatarText}</div>
                <div className="author-info">
                  <h4>{item.name}</h4>
                  <p>
                    {item.role}{' '}
                    <span>
                      •{' '}
                      {item.companyUrl ? (
                        <a
                          href={item.companyUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="testimonial-company-link"
                        >
                          {item.company} <i className="fa-solid fa-arrow-up-right-from-square" style={{ fontSize: '0.72rem', marginLeft: '3px' }}></i>
                        </a>
                      ) : (
                        item.company
                      )}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust metric summary */}
        <div className="trust-banner" style={{ marginTop: '30px' }}>
          <div className="trust-item">
            <span className="trust-num">%100</span>
            <span className="trust-lbl">{t('testimonials.trustDelivery')}</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <span className="trust-num">5.0 / 5.0</span>
            <span className="trust-lbl">{t('testimonials.trustSatisfaction')}</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <span className="trust-num">7/24</span>
            <span className="trust-lbl">{t('testimonials.trustSupport')}</span>
          </div>
        </div>
      </section>
      </div>
    </div>
  );
};

export default Testimonials;
